export const blockIconsSocialPetsNew = (
	<span className='material-symbols-outlined'>pets</span>
);
